import script from "./PushPrompt.vue?vue&type=script&lang=ts&setup=true"
export * from "./PushPrompt.vue?vue&type=script&lang=ts&setup=true"

import "./PushPrompt.vue?vue&type=style&index=0&id=6b1b8565&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1b8565"]])

export default __exports__